// Console filter to keep only call-related logs in the browser console
// Logs will be shown only if the first argument starts with "[CALL]"
(() => {
  if (typeof window === 'undefined') return;
  const originalLog = console.log.bind(console);
  const originalInfo = console.info ? console.info.bind(console) : originalLog;
  const originalWarn = console.warn ? console.warn.bind(console) : originalLog;
  // Do not override console.error to avoid hiding unexpected errors

  function shouldAllow(args: unknown[]): boolean {
    if (!args || args.length === 0) return false;
    const first = args[0];
    return typeof first === 'string' && first.startsWith('[CALL]');
  }

  console.log = (...args: unknown[]) => {
    if (shouldAllow(args)) originalLog(...args);
  };
  if (console.info) {
    console.info = (...args: unknown[]) => {
      if (shouldAllow(args)) originalInfo(...args);
    };
  }
  if (console.warn) {
    console.warn = (...args: unknown[]) => {
      if (shouldAllow(args)) originalWarn(...args);
    };
  }
})();


